import React, { useEffect, useState } from 'react';
import styles from './swipe-quota.module.scss';
import { Button, Typography } from '@/ui-kit';
import clsx from 'clsx';
import { routesApp } from '@/constans/routes';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { eventsApi } from '@/api';
import { useTranslation, Trans } from 'react-i18next';
import { formatDigitalHours, formatDigitalMinutes, HOUR, SECOND } from '@/utils/time';

interface Props {}

export const SwipeQuota: React.FC<Props> = () => {
    const getTime = (utcHours?: number) => {
        const date = new Date();
        
        if (typeof utcHours === 'number') {
            date.setUTCHours(utcHours, 0, 0, 0);   
        }
        return date.getTime();
    };

    const getTimeToSwipeReset = () => {
        const min = getTime(6); // 9:00 по мск
        const max = getTime(18); // 21:00 по мск
        const now = getTime();
        
        // от 00:00 до 09:00
        if (now < min) {
            return min - now;
        }
        // от 09:00 до 21:00
        if (now < max) {
            return max - now;
        }
        // от 21:00 до 09:00 следующего дня
        return (12 * HOUR) - (now - max);
    };

    const [leftHours, setLeftHours] = useState(formatDigitalHours(0))

    const [leftMins, setLeftMins] = useState(formatDigitalHours(0))
    
    let timer: number

    const updateTime = () => {
        const ms = getTimeToSwipeReset()
        setLeftHours(formatDigitalHours(ms))
        setLeftMins(formatDigitalMinutes(ms))
    }

    const startTimer = () => {
        stopTimer()
        timer = window.setTimeout(() => {
            updateTime()
            startTimer()
        }, SECOND)
    }

    useEffect(() => {
        updateTime()
        startTimer()
    }, [])

    const stopTimer = () => window.clearTimeout(timer)

    useEffect(() => stopTimer)

    useEffect(() => {
        const event = 'swipe_quota_screen'
        callYaMetrika(event)
        eventsApi.updateUserEvent(event)
    }, [])

    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <div className={styles.timer}>
                <Typography
                    typeColor="white"
                    className={styles.timerText}
                    fontFamily="SFProText"
                    center
                    fontWeight="semibold">
                    {leftHours}
                </Typography>
                <Typography
                    typeColor="white"
                    className={
                        clsx(
                            styles.timerText,
                            styles.timerSeparator
                        )
                    }
                    fontFamily="SFProText"
                    center
                    fontWeight="semibold">
                    :
                </Typography>
                <Typography
                    typeColor="white"
                    className={styles.timerText}
                    fontFamily="SFProText"
                    center
                    fontWeight="semibold">
                    {leftMins}
                </Typography>
            </div>
            <div className={styles.container}>
                <Typography
                    fontWeight="semibold"
                    typeColor="white"
                    className={styles.title}
                    fontFamily="SFProText"
                    center>
                    <Trans i18nKey="browse.swipe_quota_title" />
                </Typography>
                <Typography
                    typeColor="white"
                    fontFamily="SFProText"
                    center
                    className={styles.text}
                    fontWeight="normal">
                    {t('browse.swipe_quota_subtitle')}
                </Typography>
                <div className={styles.actions}>
                    <Button
                        className={
                            clsx(
                                styles.button,
                                styles.primaryBtn
                            )
                        }
                        textColor="black"
                        typeColor="white"
                        isLink
                        to={routesApp.liked}>
                        {t('browse.show_likes')}
                    </Button>
                    <Button
                        className={
                            clsx(
                                styles.button,
                                styles.secondaryBtn
                            )
                        }
                        textColor="black"
                        typeColor="white"
                        isLink
                        to={routesApp.messages}>
                        {t('browse.go_to_chat')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
